import {
    AutocompleteArrayInput as RaAutocompleteArrayInput,
    type AutocompleteArrayInputProps as RaAutocompleteArrayInputProps,
    AutocompleteInput as RaAutocompleteInput,
    type AutocompleteInputProps as RaAutocompleteInputProps,
    BooleanInput as RaBooleanInput,
    type BooleanInputProps as RaBooleanInputProps,
    DateInput as RaDateInput,
    type DateInputProps as RaDateInputProps,
    NullableBooleanInput as RaNullableBooleanInput,
    type NullableBooleanInputProps as RaNullableBooleanInputProps,
    NumberInput as RaNumberInput,
    type NumberInputProps as RaNumberInputProps,
    type RaRecord,
    SelectArrayInput as RaSelectArrayInput,
    type SelectArrayInputProps as RaSelectArrayInputProps,
    SelectInput as RaSelectInput,
    type SelectInputProps as RaSelectInputProps,
    TextInput as RaTextInput,
    type TextInputProps as RaTextInputProps,
    TimeInput as RaTimeInput,
    type TimeInputProps as RaTimeInputProps,
} from "react-admin";
import type { Operator, ValuesOf } from "../../models/enums";
import { Avatar, InputAdornment } from "@mui/material";
import { imageURL } from "../../http";

export type Op = "" | `@${ValuesOf<typeof Operator>}`;
// @ts-expect-error asd
export type Source<T> = `${keyof T}${Op}`;

export interface TextInputProps<T extends RaRecord = RaRecord>
    extends RaTextInputProps {
    source: Source<T>;
}
export function TextInput<T extends RaRecord = RaRecord>(
    props: TextInputProps<T>,
): JSX.Element {
    return <RaTextInput fullWidth {...(props)} />;
}

export interface NumberInputProps<T extends RaRecord = RaRecord>
    extends RaNumberInputProps {
    source: Source<T>;
}
export function NumberInput<T extends RaRecord = RaRecord>(
    props: NumberInputProps<T>,
): JSX.Element {
    return <RaNumberInput fullWidth {...(props)} />;
}

export interface BooleanInputProps<T extends RaRecord = RaRecord>
    extends RaBooleanInputProps {
    source: Source<T>;
}
export function BooleanInput<T extends RaRecord = RaRecord>(
    props: BooleanInputProps<T>,
): JSX.Element {
    return <RaBooleanInput fullWidth color="secondary" {...(props)} />;
}

export interface DateInputProps<T extends RaRecord = RaRecord>
    extends RaDateInputProps {
    source: Source<T>;
}
export function DateInput<T extends RaRecord = RaRecord>(
    props: DateInputProps<T>,
): JSX.Element {
    return <RaDateInput fullWidth {...(props)} />;
}
// @ts-expect-error asd
export interface AutocompleteInputProps<T extends RaRecord = RaRecord>
    extends RaAutocompleteInputProps {
    source: Source<T>;
    optionValue?: keyof T;
}
export function AutocompleteInput<T extends RaRecord = RaRecord>(
    props: AutocompleteInputProps<T>,
): JSX.Element {

    return <RaAutocompleteInput 
        fullWidth
        // TextFieldProps={{ slotProps: { input: { startAdornment: undefined } } }}
        // @ts-expect-error asd
        adornment={(record?: T) => 
            <InputAdornment position="start" sx={{ mr: 0 }}>
                <Avatar 
                    variant="rounded" 
                    sx={{ height: 24, width: 24, ml: 1 }} 
                    src={record?.image ? imageURL(record.image) : undefined} 
                />
            </InputAdornment>
        }
        {...(props)} />;
}

export interface AutocompleteArrayInputProps<T extends RaRecord = RaRecord>
    extends RaAutocompleteArrayInputProps {
    source: Source<T>;
}
export function AutocompleteArrayInput<T extends RaRecord = RaRecord>(
    props: AutocompleteArrayInputProps<T>,
): JSX.Element {
    return <RaAutocompleteArrayInput fullWidth TextFieldProps={{ slotProps: { input: { startAdornment: undefined } } }} {...(props)} />;
}

export interface NullableBooleanInputProps<T extends RaRecord = RaRecord>
    extends RaNullableBooleanInputProps {
    source: Source<T>;
}
export function NullableBooleanInput<T extends RaRecord = RaRecord>(
    props: NullableBooleanInputProps<T>,
): JSX.Element {
    return <RaNullableBooleanInput fullWidth {...(props)} />;
}


export interface SelectInputProps<T extends RaRecord = RaRecord>
    extends RaSelectInputProps {
    source: Source<T>;
}
export function SelectInput<T extends RaRecord = RaRecord>(
    props: SelectInputProps<T>,
): JSX.Element {
    return <RaSelectInput fullWidth {...(props)} />;
}

export interface SelectArrayInputProps<T extends RaRecord = RaRecord>
    extends RaSelectArrayInputProps {
    source: Source<T>;
}
export function SelectArrayInput<T extends RaRecord = RaRecord>(
    props: SelectArrayInputProps<T>,
): JSX.Element {
    return <RaSelectArrayInput fullWidth {...(props)} />;
}

export interface TimeInputProps<T extends RaRecord = RaRecord>
    extends RaTimeInputProps {
    source: Source<T>;
}
export function TimeInput<T extends RaRecord = RaRecord>(
    props: TimeInputProps<T>,
): JSX.Element {
    return <RaTimeInput fullWidth {...(props)} />;
}
